module.exports = __webpack_public_path__ + "img/hand-swipe.01930fb2.svg";